import { useEffect, useRef, useState } from 'react';

const TOP_REVEAL_PX = 8;
const DELTA_THRESHOLD_PX = 6;

/**
 * Returns true while the user is scrolling down the page (past the top),
 * and false when scrolling up or near the top. Useful for auto-hiding chrome.
 */
export function useHideOnScrollDown(resetKey?: string) {
  const [hidden, setHidden] = useState(false);
  const lastYRef = useRef(0);
  const hiddenRef = useRef(false);

  // A new key (e.g. another page) shows the chrome again.
  const [shownFor, setShownFor] = useState(resetKey);
  if (shownFor !== resetKey) {
    setShownFor(resetKey);
    setHidden(false);
  }

  useEffect(() => {
    hiddenRef.current = false;
    lastYRef.current = window.scrollY;
  }, [resetKey]);

  useEffect(() => {
    lastYRef.current = window.scrollY;

    const onScroll = () => {
      const y = window.scrollY;
      const delta = y - lastYRef.current;

      if (y <= TOP_REVEAL_PX) {
        if (hiddenRef.current) {
          hiddenRef.current = false;
          setHidden(false);
        }
      } else if (delta > DELTA_THRESHOLD_PX) {
        if (!hiddenRef.current) {
          hiddenRef.current = true;
          setHidden(true);
        }
      } else if (delta < -DELTA_THRESHOLD_PX) {
        if (hiddenRef.current) {
          hiddenRef.current = false;
          setHidden(false);
        }
      }

      lastYRef.current = y;
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return hidden;
}
